export const filterBarSelectStyles = {
  control: (base, state) => ({
    height: '1.5rem',
    width: '100%',
    fontWeight: '400',
    color: '#3f4254',
    border: '1px solid',
    backgroundColor: 'white',
    borderColor: state.isFocused ? '#0C8298' : '#e4e6ef',
    boxShadow: state.isFocused ? null : null,
    borderRadius: '.42rem',
    fontSize: '1rem',
    lineHeight: 1,
    paddingLeft: '3rem',
    flexBasis: 'unset',
    flexGrow: 'unset',
    flexShrink: 'unset',
  }),
  valueContainer: (base) => ({
    ...base,
    display: 'block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '0.2rem 1rem 0 0.5rem',
  }),
  singleValue: () => ({
    paddingBottom: '0.1rem',
  }),
  placeholder: () => ({
    position: 'absolute',
    top: '13%',
  }),
  dropdownIndicator: () => ({
    position: 'absolute',
    top: '9%',
    left: '1.8rem',
    borderLeft: '2px solid #0C8298',
    color: '#0C8298',
    background: '#ffffff',
    display: 'flex',
    justifyContent: 'flex-end',
    width: '25px',
  }),
  menu: (base) => ({
    ...base,
    top: '73%',
    fontSize: '1rem',
    zIndex: 999
  }),
  input: () => ({
    marginTop: 0,
    marginBottom: 0
  })
};

export const existingReceiptDataSelectStyles = {
  control: (base, state) => ({
    height: '1.72rem',
    fontWeight: '400',
    color: '#3f4254',
    border: '1px solid',
    backgroundColor: 'white',
    borderColor: state.isFocused ? '#0C8298' : '#e4e6ef',
    boxShadow: state.isFocused ? null : null,
    borderRadius: '.42rem',
    fontSize: '0.9rem',
  }),
  singleValue: () => ({
    position: 'absolute',
    top: '13%',
    maxWidth: '350px',
    textOverflow: 'ellipsis'
  }),
  placeholder: () => ({
    position: 'absolute',
    top: '8%',
  }),
  dropdownIndicator: () => ({
    position: 'absolute',
    top: '9%',
    left: '0.3rem',
    color: '#0C8298',
    background: '#ffffff',
  }),
  menu: (base) => ({
    ...base,
    top: '73%',
    zIndex: '99',
  }),
  input: () => ({
    marginTop: 0,
    marginBottom: 0
  }),
  indicatorsContainer: (base) => ({
    ...base,
    position: 'absolute',
    top: '1px',
    left: 0
  }),
  loadingIndicator: (base) => ({
    ...base,
    right: '-4rem',
    top: '0.2rem',
    position: 'absolute'
  }),
};

export const addReceiptGridSelectStyles = {
  control: (base, state) => ({
    height: '1.72rem',
    fontWeight: '400',
    color: '#3f4254',
    border: '1px solid',
    backgroundColor: 'white',
    borderColor: state.isFocused ? '#0C8298' : '#e4e6ef',
    boxShadow: state.isFocused ? null : null,
    borderRadius: '.42rem',
    fontSize: '0.9rem',
    position: 'relative',
  }),
  singleValue: () => ({
    position: 'absolute',
    top: '8%',
  }),
  container: (base) => ({
    ...base,
    width: '100%',
    position: 'static',
  }),
  placeholder: () => ({
    position: 'absolute',
    top: '8%',
  }),
  dropdownIndicator: () => ({
    position: 'absolute',
    top: 'inherit',
    left: '0.3rem',
    color: '#0C8298',
    background: '#ffffff',
  }),
  menu: (base) => ({
    ...base,
    top: 'initial',
    position: 'absolute',
    width: '200px',
    zIndex: 999,
  }),
  input: () => ({
    marginTop: 0,
    marginBottom: 0
  }),
  indicatorsContainer: (base) => ({
    ...base,
    position: 'absolute',
    left: 0,
    top: '1px'
  }),
};

export const commonSelectStyles = {
  control: (base, state) => ({
    height: '1.72rem',
    fontWeight: '400',
    color: '#3f4254',
    border: '1px solid',
    backgroundColor: 'white',
    borderColor: state.isFocused ? '#0C8298' : '#e4e6ef',
    boxShadow: state.isFocused ? null : null,
    borderRadius: '.42rem',
    fontSize: '0.9rem',
  }),
  singleValue: () => ({
    position: 'absolute',
    top: '13%',
    maxWidth: '350px',
    textOverflow: 'ellipsis'
  }),
  placeholder: () => ({
    position: 'absolute',
    top: '8%',
  }),
  dropdownIndicator: () => ({
    position: 'absolute',
    top: '9%',
    left: '0.3rem',
    color: '#0C8298',
    background: '#ffffff',
  }),
  menu: (base) => ({
    ...base,
    top: '73%',
    zIndex: '99',
  }),
  input: () => ({
    marginTop: 0,
    marginBottom: 0
  }),
  indicatorsContainer: (base) => ({
    ...base,
    position: 'absolute',
    top: '1px',
    left: 0
  }),
  loadingIndicator: (base) => ({
    ...base,
    right: '-4rem',
    top: '0.2rem',
    position: 'absolute'
  }),
};

export const userDataHistorySelectStyles = {
  control: (base, state) => ({
    height: '1.72rem',
    fontWeight: '400',
    color: '#3f4254',
    border: '1px solid',
    backgroundColor: 'white',
    borderColor: '#0d6efd',
    borderRadius: '.42rem',
    fontSize: '0.85rem',
    width: '175px',
  }),
  singleValue: () => ({
    position: 'absolute',
    top: '13%',
    textOverflow: 'ellipsis'
  }),
  placeholder: () => ({
    position: 'absolute',
    top: '8%',
  }),
  dropdownIndicator: (state) => ({
    position: 'absolute',
    top: '9%',
    left: '0.3rem',
    color: '#0d6efd',
    background: '#ffffff',
  }),
  menu: (base) => ({
    ...base,
    top: '20px',
    border: '1px solid',
    backgroundColor: 'white',
    borderColor: '#0d6efd',
    zIndex: '99',
  }),
  input: () => ({
    marginTop: 0,
    marginBottom: 0
  }),
  indicatorsContainer: (base) => ({
    ...base,
    position: 'absolute',
    top: '1px',
    left: 0
  }),
  loadingIndicator: (base) => ({
    ...base,
    right: '-4rem',
    top: '0.2rem',
    position: 'absolute'
  }),
  option: (base) => ({
    ...base,
    fontSize: '0.85rem',
  })
};

export const transfersSelectStyles = {
  control: (base, state) => ({
    height: '2.625rem',
    fontWeight: '400',
    color: '#333',
    border: '1px solid',
    backgroundColor: 'white',
    borderColor: state.isFocused ? '#333' : '#ccc',
    boxShadow: state.isFocused ? null : null,
    borderRadius: '6px',
    fontSize: '13px',
  }),
  valueContainer: (base) => ({
    ...base,
    height: '2.625rem',
  }),
  placeholder: () => ({
    position: 'absolute',
    top: '25%',
  }),
  dropdownIndicator: () => ({
    position: 'absolute',
    top: '60%',
    left: '0.3rem',
    color: '#0C8298',
    background: '#ffffff',
  }),
  menu: (base) => ({
    ...base,
    top: '85%',
    zIndex: '99',
  }),
  input: () => ({
    marginTop: 0,
    marginBottom: 0
  }),
  indicatorsContainer: (base) => ({
    ...base,
    position: 'absolute',
    top: '1px',
    left: 0
  }),
  loadingIndicator: (base) => ({
    ...base,
    right: '-4rem',
    top: '50%',
    position: 'absolute'
  }),
};

export const transferEditSelectStyles = {
  control: (base, state) => ({
    height: '1.875rem',
    fontWeight: '400',
    color: '#333',
    border: '1px solid',
    backgroundColor: state.isDisabled ? '#F4F6F9' : 'white',
    borderColor: state.isFocused ? '#333' : '#ccc',
    boxShadow: state.isFocused ? null : null,
    borderRadius: '4px',
    fontSize: '13px',
  }),
  singleValue: () => ({
    position: 'absolute',
    top: '13%',
    maxWidth: '350px',
    textOverflow: 'ellipsis'
  }),
  placeholder: () => ({
    position: 'absolute',
    top: '8%',
  }),
  dropdownIndicator: (base, state) => ({
    position: 'absolute',
    top: '25%',
    left: '0.3rem',
    color: '#0C8298',
    background: state.isDisabled ? '#F4F6F9' : 'white',
  }),
  menu: (base) => ({
    ...base,
    top: '73%',
    zIndex: '99',
  }),
  input: () => ({
    marginTop: 0,
    marginBottom: 0
  }),
  indicatorsContainer: (base) => ({
    ...base,
    position: 'absolute',
    top: '1px',
    left: 0
  }),
  loadingIndicator: (base) => ({
    ...base,
    right: '-4rem',
    top: '0.2rem',
    position: 'absolute'
  }),
};


